import { render, staticRenderFns } from "./moreIcon.vue?vue&type=template&id=0c2cf855&scoped=true"
import script from "./moreIcon.vue?vue&type=script&lang=js"
export * from "./moreIcon.vue?vue&type=script&lang=js"
import style0 from "./moreIcon.vue?vue&type=style&index=0&id=0c2cf855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cf855",
  null
  
)

export default component.exports